import { styled } from "@linaria/react";
import React, { useMemo } from "react";
import usePublicConstants from "features/ServerConstants/hooks/usePublicConstants";

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export interface HeadlinePreviewProps {
  className?: string;
}
export interface HeadlinePreviewProps {
  className?: string;
}

const BanerImage = ({ className }: HeadlinePreviewProps) => {
  const {data} = usePublicConstants();

  const backgroundSrc = useMemo(() => {
    const values = data?.Constant.find((i) => i.name === "Close Content")?.value;

    if (!values) {
      return null
    }

    const json = JSON.parse(`${values}`);
    if (typeof json !== "object") {
      return null
    }

    return json.background;
  }, [data]);

  return backgroundSrc ? <Image src={backgroundSrc} className={className} /> : null
};

export default BanerImage;





